/* eslint-disable max-len */
import React, { useMemo } from 'react';
import SplitPane from 'react-split-pane';
import useLocalStorage from 'react-use/lib/useLocalStorage';
import { LFC } from '../../../Legacy';
import { ApiClient } from '../../../api/ApiClient';
import { v2 } from '../../../api/ApiInterfaceV2';
import { useLoader } from '../../../platform/Hook';
import { Colors, remInPx } from '../../../ui';
import { Badge } from '../../../ui/Badge';
import { Fill } from '../../../ui/Fill';
import { InfoView } from '../../../ui/InfoView';
import { LoadingGuard } from '../../../ui/LoadingGuard';
import { VerticalTabSet } from '../../../ui/VerticalTabSet';
import { UseLocationScope } from '../../AppLocation';
import { useResolve } from '../../Container';
import { AccountHeaderBlock } from '../../account/AccountHeaderBlock';
import { PlanStateHeaderBlock } from '../../account/PlanStateHeaderBlock';
import { Crumbs } from '../../common/Crumbs';
import { Page } from '../../common/Page';
import { Flexer } from '../../dashboard/elements/LayoutElements';

const XSplitPane = SplitPane as any;

const { Section,
    LargeHeading, Heading, HeadingAction,
    DetailTable, DetailRow, DetailCell, DetailAction,
    ListItem, ListLabel, ListAction,
} = InfoView;

const ManageIntegrationsLayout: LFC<{ param?: string }> = ({ param }) => {

    const [leftSize, setLeftSize] = useLocalStorage('deqo/ui/integrations/leftSize', remInPx(18));

    const api = useResolve(ApiClient);

    const [loading, list] = useLoader(async () => api.exec(v2.admin.integrations.list()), []);
    const active = useMemo(() => list?.find(x => x.name === param) ?? (list || [])[0] ?? null, [list, param]);

    return <Fill flex="column">
        <LoadingGuard loading={loading}>
            {list && active && <>
                <VerticalTabSet>
                    <XSplitPane className="flex" split="vertical" minSize={remInPx(12)} size={leftSize} maxSize={remInPx(30)} onChange={setLeftSize}>
                        <VerticalTabSet.Menu expand>
                            {list.map(it =>
                                <VerticalTabSet.Link key={it.name} to={`~/manage/integrations/${it.name}`} selected={active === it}>
                                    {it.label}
                                </VerticalTabSet.Link>
                            )}
                        </VerticalTabSet.Menu>
                        <VerticalTabSet.Content>
                            <InfoView>
                                <Section>
                                    <LargeHeading>{active.label}</LargeHeading>
                                </Section>
                                <Section>
                                    <Heading>
                                        Information
                                        {/* <HeadingAction onClick={onRemoveUserClick}>Remove Person</HeadingAction> */}
                                    </Heading>
                                    <DetailTable>
                                        <DetailRow>
                                            <DetailCell shrink>Description:</DetailCell>
                                            <DetailCell>{active.description}</DetailCell>
                                        </DetailRow>
                                        <DetailRow>
                                            <DetailCell shrink>Status:</DetailCell>
                                            <DetailCell>
                                                <Flexer flex="row" align="center">
                                                    {active.enabled && <Badge size="lg" color={Colors.positive}>Active</Badge>}
                                                    {!active.enabled && <span>Not Active</span>}
                                                </Flexer>
                                            </DetailCell>
                                        </DetailRow>
                                    </DetailTable>
                                </Section>
                                {/* {active.enabled && <>
                                    {active.name === 'atlassian' && <ManageAtlassianIntegrationView data={active} />}
                                </>} */}
                            </InfoView>
                        </VerticalTabSet.Content>
                    </XSplitPane>
                </VerticalTabSet>
            </>}
        </LoadingGuard>

    </Fill>;
};

export const ManageIntegrationsView: LFC<{ param?: string }> = ({ param }) => <>
    <UseLocationScope name="access" label="Integrations" />
    <Page.Header>
        <Crumbs items={[
            ['Manage', '/manage'],
            ['Integrations', null],
        ]} />
        <Page.HeaderPush>
            <PlanStateHeaderBlock />
            <AccountHeaderBlock />
        </Page.HeaderPush>
    </Page.Header>
    <Page.Content>
        <ManageIntegrationsLayout param={param} />
    </Page.Content>
</>;
